/* eslint-disable @wyz/module/no-relative-import */
import { Table } from '@wyz/ui';
import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import './quote-table.scss';
function QuoteTable({
  pointOfSaleView,
  children,
}: PropsWithChildren<{ pointOfSaleView: boolean }>) {
  return (
    <Table
      className={clsx('product-table quote-table', {
        'customer-view': !pointOfSaleView,
      })}
      bordered
      style={{ tableLayout: 'fixed' }}
    >
      {children}
    </Table>
  );
}

export default QuoteTable;
